import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPdf = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M3.99927 13.9987V8.99866",
			stroke: "#ADB3C4",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4 9H4.5C4.89782 9 5.27936 9.15804 5.56066 9.43934C5.84196 9.72064 6 10.1022 6 10.5C6 10.8978 5.84196 11.2794 5.56066 11.5607C5.27936 11.842 4.89782 12 4.5 12H4",
			stroke: "#ADB3C4",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 14C8.53043 14 9.03914 13.7893 9.41421 13.4142C9.78929 13.0391 10 12.5304 10 12V11C10 10.4696 9.78929 9.96086 9.41421 9.58579C9.03914 9.21071 8.53043 9 8 9V14Z",
			stroke: "#ADB3C4",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 14V10C12 9.73478 12.1054 9.48043 12.2929 9.29289C12.4804 9.10536 12.7348 9 13 9H14",
			stroke: "#ADB3C4",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.9993 11.9987H13.4993",
			stroke: "#ADB3C4",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.2059 4.70599C16.3935 4.89335 16.499 5.14753 16.4993 5.41266V15C16.4989 15.3975 16.3408 15.7786 16.0597 16.0596C15.7786 16.3406 15.3974 16.4985 14.9999 16.4987H2.99993C2.60223 16.4988 2.22073 16.3411 1.93931 16.06C1.6579 15.779 1.49962 15.3977 1.49927 15V2.99999C1.49909 2.80284 1.53778 2.60759 1.61313 2.4254C1.68847 2.24322 1.799 2.07767 1.93837 1.93823C2.07775 1.79879 2.24324 1.6882 2.4254 1.61277C2.60755 1.53735 2.80278 1.49857 2.99993 1.49866H12.5846C12.7159 1.4986 12.846 1.52441 12.9674 1.57463C13.0887 1.62485 13.199 1.69848 13.2919 1.79132L16.2059 4.70599Z",
			stroke: "#ADB3C4",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.4993 1.49866V4.49866C12.4993 4.76387 12.6046 5.01823 12.7922 5.20576C12.9797 5.3933 13.2341 5.49866 13.4993 5.49866H16.4993",
			stroke: "#ADB3C4",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgPdf);
export default ForwardRef;
